import $ from "jquery";
import loader_gif from "../../images/preloader.gif";

export class Brand {
    constructor(isMobile = false) {
        this.isMobile = isMobile;
        this._events();
    }

    _events() {
        $('body')
            .on('click.get.brand.description', 'a[data-open="brandDescription"]', this._getBrandDescription.bind(this))
        ;
    }

    _getBrandDescription(e) {
        event.preventDefault();
        let $item = $(e.currentTarget);
        let $revealContent = $('#brandDescription [data-brand-content]');

        $.ajax({
            url: '/q/get_brand_description',
            method: 'POST',
            data: $item.data(),
            beforeSend: () => {
                $revealContent
                    .html(
                        '<div class="text-center"><img class="' +
                        (this.isMobile ? 'width-20' : 'width-10') + '" src="' + loader_gif +
                        '" alt="Загрузка..."></div>'
                    )
            }
        }).then((data) => {
            $revealContent.html(data.result);
        }).catch((error) => {
            $revealContent.html(error.responseJSON.error)
        });
    }
}
